/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import WpIcon from 'Wpds/components/icon/WpIcon';

class SalesforceSyncPanel extends Component {
  render() {
    const { salesforce_organization_data_source } = this.props;

    let icon_class = '';
    let status_message = '';
    let show_connect_button = false;
    let show_change_connected_salesforce_account_button = false;
    if (!salesforce_organization_data_source) {
      icon_class = 'text-danger';
      status_message = 'Salesforce connection not found';
      show_connect_button = true;
    } else if (!salesforce_organization_data_source.has_authorization) {
      icon_class = 'text-danger';
      status_message = 'Salesforce was disconnected';
      show_connect_button = true;
    } else {
      switch (salesforce_organization_data_source.sync_status.status) {
        case 'never_synced':
          icon_class = 'text-warning';
          status_message = 'Salesforce not synced';
          break;
        case 'partial_historical_sync':
          icon_class = 'fa-spin fa-sync-alt';
          status_message = 'Salesforce sync in progress';
          break;
        case 'in_sync':
          icon_class = 'text-success';
          status_message = `Salesforce was synced ${salesforce_organization_data_source.sync_status.last_sync_time_humanized}`;
          show_change_connected_salesforce_account_button = true;
          break;
        case 'out_of_sync':
          icon_class = 'text-warning';
          status_message = `Salesforce was synced ${salesforce_organization_data_source.sync_status.last_sync_time_humanized}`;
          show_change_connected_salesforce_account_button = true;
          break;
      }
    }

    return (
      <small className="text-muted d-block">
        <span className={`mr-1 ${icon_class}`}>
          <WpIcon name="circle" prefix="fas" />
        </span>
        {status_message}
        {show_connect_button && (
          <p>
            <a href="/oauth2/salesforce_signup?redirect_url=/assistants/sales/import_salesforce_users">Connect Salesforce</a>
          </p>
        )}
        {show_change_connected_salesforce_account_button && (
          <p className="mt-2">
            <a href="/oauth2/salesforce_signup?redirect_url=/assistants/sales/import_salesforce_users">Switch connected Salesforce Account</a>
          </p>
        )}
      </small>
    );
  }
}

const mapStateToProps = state => ({
  salesforce_organization_data_source: state.organization.salesforce_organization_data_source,
});

export default connect(mapStateToProps)(SalesforceSyncPanel);
